/* src/app/modules/portal/components/embeddedView/embeddedView.component.css */
#iframe-container {
  overflow: hidden;
  flex: 1 0;
  height: 100%;
}
iframe {
  height: 100%;
  width: 100%;
  border: none;
  flex: 1;
}
:host {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  height: 100%;
}
/*# sourceMappingURL=embeddedView.component.css.map */
